import { EventEmitter } from "events";
export class ConsumerStore {
    static EVENT_NAME = "update";
    content = undefined;
    eventEmitter = new EventEmitter();
    setContent(content) {
        this.content = content;
        this.eventEmitter.emit(ConsumerStore.EVENT_NAME);
    }
    getContent() {
        return this.content;
    }
    addListener(listener) {
        this.eventEmitter.addListener(ConsumerStore.EVENT_NAME, listener);
    }
    removeListener(listener) {
        this.eventEmitter.removeListener(ConsumerStore.EVENT_NAME, listener);
    }
}
//# sourceMappingURL=consumer.js.map